const { get } = require('./retriever');
/**
 * prefixes sid value of the passed config object
 * @param {Object} trackingConfig
 * @param {String} pageId
 * @returns {Object} updated config object
 */
const VI_DWEB_PAGE_ID = '2047675';

const prefixPageId = (trackingConfig, pageId) => {
    if (!trackingConfig) {
        return null;
    }

    const partialSid = get(trackingConfig, 'eventProperty.sid', '');
    const sid = pageId
        ? `p${pageId}.${partialSid}`
        : partialSid;

    return (Object.assign({}, trackingConfig,
        {
            eventProperty: {
                sid
            }
        })
    );
};

/**
 *  VI-dweb uses data-vi-tracking attribute and Raptor desktop has different
    setup for pulsar tracking. This method must be used for the components used for vi-dweb
 * @param {object} data - tracking data object
 * @returns tracking attribute object value with proper attribute name depending upon pageId
 */
const getTracking = (data) => {
    if (!data) {
        return null;
    } else if (data.operationId === VI_DWEB_PAGE_ID) {
        return ({ 'data-vi-tracking': JSON.stringify(data) });
    }
    return ({ 'data-track': JSON.stringify(data) });
};

/**
 * dispatches pulsar event with the tracking details
 * @param {Object} Event
 */
const trackEvent = (e) => {
    // check for the event type
    const element = e.originalEvent
        ? e.originalEvent.target.closest('[data-track]')
        : e.target.closest('[data-track]');
    const trackingData = element && element.dataset && element.dataset.track;
    const trackingObj = trackingData ? JSON.parse(trackingData) : null;
    if (trackingObj) {
        document.dispatchEvent(new CustomEvent('pulsar', { detail: trackingObj }));
    }
};

module.exports = {
    prefixPageId,
    trackEvent,
    getTracking
};
